export const SUPPORT_SECTION = 'support';

export const THREAD_PAGE_SIZE = 20;
export const MESSAGE_PAGE_SIZE = 50;

export const THREADS_POLL_MS = 12000;
export const MESSAGES_POLL_MS = 4000;
export const SUMMARY_POLL_MS = 45000;
export const ATTACHMENT_REFRESH_MS = 8 * 60 * 1000;

export const MEDIA_LIMITS_MB = { image: 10, video: 50, file: 50 };

export const MESSAGE_TEXT_LIMIT = 8000;

export const FILE_ACCEPT = 'image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.zip,.rar';

export const THREAD_STATUS = {
  new: { label: 'Новое', className: 'bg-orange-100 text-orange-700' },
  in_progress: { label: 'В работе', className: 'bg-sky-100 text-sky-700' },
  closed: { label: 'Закрыто', className: 'bg-gray-200 text-gray-600' },
};

export const STATUS_OPTIONS = [
  { value: '', label: 'Все статусы' },
  { value: 'new', label: 'Новые' },
  { value: 'in_progress', label: 'В работе' },
  { value: 'closed', label: 'Закрытые' },
];
